module.exports = __webpack_public_path__ + "img/fill.00a80a6e.svg";